export const isPositionWithinHorizontalBounds = (pos, bounds) => {
  return pos.x >= bounds.left && pos.x <= bounds.right;
};
export const isPositionWithinVerticalBounds = (pos, bounds) => {
  return pos.y >= bounds.top && pos.y <= bounds.bottom;
};
export const isPositionWithinBounds = (pos, bounds) => {
  return isPositionWithinVerticalBounds(pos, bounds) && isPositionWithinHorizontalBounds(pos, bounds);
};
export const isPositionToTheLeftOfBounds = (pos, bounds) => {
  return isPositionWithinBounds(pos, {
    top: bounds.top,
    bottom: bounds.bottom,
    left: Number.NEGATIVE_INFINITY,
    right: bounds.left
  });
};
export const getIsPositionInBufferOfBounds = (pos, bounds, bufferDistance) => {
  const isLeftBuffer = isPositionWithinBounds(pos, Object.assign({}, bounds, {
    left: bounds.left - bufferDistance,
    right: bounds.left
  }));
  const isRightBuffer = isPositionWithinBounds(pos, Object.assign({}, bounds, {
    left: bounds.right,
    right: bounds.right + bufferDistance
  }));
  const isTopBuffer = isPositionWithinBounds(pos, Object.assign({}, bounds, {
    bottom: bounds.top,
    top: bounds.top - bufferDistance
  }));
  const isBottomBuffer = isPositionWithinBounds(pos, Object.assign({}, bounds, {
    top: bounds.bottom,
    bottom: bounds.bottom + bufferDistance
  }));
  if (!(isLeftBuffer || isRightBuffer || isTopBuffer || isBottomBuffer)) {
    return null;
  }
  return {
    isLeftBuffer,
    isRightBuffer,
    isTopBuffer,
    isBottomBuffer
  };
};
export const isPositionToTheRightOfBounds = (pos, bounds) => {
  return isPositionWithinBounds(pos, {
    top: bounds.top,
    bottom: bounds.bottom,
    left: bounds.right,
    right: Infinity
  });
};
export const isPositionAboveBounds = (pos, bounds) => pos.y < bounds.top;
export const isPositionBelowBounds = (pos, bounds) => pos.y > bounds.bottom;
export const doBoundsIntersect = (bounds1, bounds2) => {
  return !(bounds2.left > bounds1.right || bounds2.right < bounds1.left || bounds2.top > bounds1.bottom || bounds2.bottom < bounds1.top);
};
export const doOffsetAndBoundsIntersect = (bounds1, bounds2) => {
  return !(bounds2.left > bounds1.offsetRight || bounds2.right < bounds1.offsetLeft || bounds2.top > bounds1.offsetBottom || bounds2.bottom < bounds1.offsetTop);
};
export const doBoundsIntersectMoreThanEdges = (bounds1, bounds2) => {
  return !(bounds2.left >= bounds1.right || bounds2.right <= bounds1.left || bounds2.top >= bounds1.bottom || bounds2.bottom <= bounds1.top);
};
export const isSamePosition = (p1, p2) => {
  if (p1 == null || p2 == null) {
    return false;
  }
  return p1.x === p2.x && p1.y === p2.y;
};
export const isSameBoundingRect = (b1, b2) => {
  if (b1 == null || b2 == null) {
    return false;
  }
  return b1.left === b2.left && b1.top === b2.top && b1.width === b2.width && b1.height === b2.height;
};